import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import ErrorPage from './ErrorPageView';
import { Contact } from './styles';
import AppContext from '../AppContext';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';
import { externalHostSelector } from '../ConsumerArea/ConsumerAreaSelector';
import { EXTERNAL_HOST } from '../ConsumerArea/ConsumerAreaConstants';

const PageNotFound = () => {
  const appContext = useContext(AppContext);

  useDocumentTitle('Page Not Found');

  const externalHost = useSelector(externalHostSelector);

  const hideEmail = [EXTERNAL_HOST.MONETA, EXTERNAL_HOST.WEALTHCARE, EXTERNAL_HOST.CARSON].includes(
    externalHost,
  );

  return (
    <ErrorPage
      icon="fas fa-search"
      title="Page not found."
      message={
        <>
          The page you&#8217;re looking for has been removed or unavailable.
          <br />
          Please try again in a few minutes.
          {!hideEmail && (
            <>
              If the error persists{' '}
              <Contact href="mailto:financialplanning@orion.com">contact us</Contact> for support.
            </>
          )}
        </>
      }
      button={{
        text: 'Go to Homepage',
        onClick: () => {
          ADV.util.Router.go2(appContext.defaultController, appContext.defaultParams);
        },
      }}
    />
  );
};

export default PageNotFound;
